import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("tcf_access_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user); setOrg(data.organization);
    } catch (e) {
      localStorage.removeItem("tcf_access_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password, remember = false) => {
    const { data } = await api.post("/auth/login", { email, password, remember_me: remember });
    localStorage.setItem("tcf_access_token", data.access_token);
    localStorage.setItem("tcf_refresh_token", data.refresh_token);
    setUser(data.user); setOrg(data.organization);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("tcf_access_token", data.access_token);
    localStorage.setItem("tcf_refresh_token", data.refresh_token);
    setUser(data.user); setOrg(data.organization);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("tcf_access_token");
    localStorage.removeItem("tcf_refresh_token");
    setUser(null); setOrg(null);
    window.location.href = "/login";
  };

  const updateOrg = (newOrg) => setOrg(newOrg);

  return (
    <AuthCtx.Provider value={{ user, org, loading, login, register, logout, refresh, updateOrg }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
